export const validSurrogatePair = function (str) {
  for (let i=0; i<str.length; i++) {
    const c = str.charCodeAt(i);
    if ((0xD800 <= c && c <= 0xDBFF) || (0xDC00 <= c && c <= 0xDFFF)) {
      return true;
    }
  }
  return false;
}
